import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  SEND_CODE_REQUEST,
  VERIFY_CODE_REQUEST,
  REGISTER_USER,
} from "./actionTypes";
import {
  sendCodeSuccess,
  sendCodeFailure,
  verifyCodeSuccess,
  verifyCodeFailure,
  registerUserSuccessful,
  registerUserFailed,
} from "./actions";

import {
  verifyEmail,
  verifySessionCode,
  setPassword,
} from "../../../helpers/backend-helper";
import { setThemeColor, loginSuccess } from "store/actions";

function* sendCode({ payload: { firstName, lastName, email } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const res = yield call(verifyEmail, { firstName, lastName, email });
      yield put(sendCodeSuccess(email, res.message));
    } else {
      yield put(sendCodeSuccess(email, "Code sent (fake). Use 123456"));
    }
  } catch (error) {
    yield put(sendCodeFailure(error.response?.data?.message || error.message || error));
  }
}

function* verifyCode({ payload: { email, code, consentMarketing } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const res = yield call(verifySessionCode, {
        email,
        code,
        consentMarketing: Boolean(consentMarketing),
      });
      yield put(verifyCodeSuccess(res.email, res.message));
    } else {
      if (code === "123456") {
        yield put(verifyCodeSuccess(null, "Verified (fake)"));
      } else {
        throw new Error("Invalid verification code");
      }
    }
  } catch (error) {
    yield put(verifyCodeFailure(error.response?.data?.message || error.message || error));
  }
}

function* registerUser({ payload: { email, password, role, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const { data } = yield call(setPassword, { email, password, role });

      const user = data?.user;
      yield put(registerUserSuccessful({ userInfo: user }));
      yield put(loginSuccess(user));
      yield put(setThemeColor(user?.company?.primaryColor || "#06427a"));

      localStorage.setItem("themeColor", user?.company?.primaryColor || "#06427a");
    }
  } catch (error) {
    yield put(registerUserFailed(error.response?.data?.message || error.message || error));
  }
}

function* watchSendCode() {
  yield takeEvery(SEND_CODE_REQUEST, sendCode);
}
function* watchVerifyCode() {
  yield takeEvery(VERIFY_CODE_REQUEST, verifyCode);
}
function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser);
}

export default function* accountSaga() {
  yield all([fork(watchSendCode), fork(watchVerifyCode), fork(watchUserRegister)]);
}
